import { render, staticRenderFns } from "./proposal.vue?vue&type=template&id=901a5372&scoped=true&"
import script from "./proposal.vue?vue&type=script&lang=ts&"
export * from "./proposal.vue?vue&type=script&lang=ts&"
import style0 from "./proposal.vue?vue&type=style&index=0&id=901a5372&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "901a5372",
  null
  
)

export default component.exports